import React, { useState, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { ChargingRange, CHARGE_TYPE_FIXED, CHARGE_TYPE_PERCENTAGE } from '../api/charging/data';

interface ChargingRangeFormProps {
    initialRange?: ChargingRange;
    onRangeChange?: (range: ChargingRange) => void;
}

const ChargingRangeForm: React.FC<ChargingRangeFormProps> = ({ initialRange, onRangeChange }) => {
    const [range, setRange] = useState<ChargingRange>({
        id: '',
        minAmount: 0,
        maxAmount: 0,
        charge: 0,
        chargeType: CHARGE_TYPE_FIXED
    });

    useEffect(() => {
        if (initialRange) {
            setRange(initialRange);
        }
    }, [initialRange]);

    useEffect(() => {
        if (onRangeChange) {
            onRangeChange(range);
        }
    }, [range, onRangeChange]);

    return (
        <Form>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Minimum Amount (P)</Form.Label>
                        <Form.Control
                            type="number"
                            step="0.01"
                            value={range.minAmount}
                            onChange={(e) => setRange({ ...range, minAmount: parseFloat(e.target.value) || 0 })}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Maximum Amount (P)</Form.Label>
                        <Form.Control
                            type="number"
                            step="0.01"
                            value={range.maxAmount}
                            onChange={(e) => setRange({ ...range, maxAmount: parseFloat(e.target.value) || 0 })}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Charge Amount</Form.Label>
                        <Form.Control
                            type="number"
                            step="0.01"
                            value={range.charge}
                            onChange={(e) => setRange({ ...range, charge: parseFloat(e.target.value) || 0 })}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Charge Type</Form.Label>
                        <Form.Select
                            value={range.chargeType}
                            onChange={(e) => setRange({ ...range, chargeType: e.target.value as 'fixed' | 'percentage' })}
                        >
                            <option value={CHARGE_TYPE_FIXED}>Fixed Amount</option>
                            <option value={CHARGE_TYPE_PERCENTAGE}>Percentage</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
        </Form>
    );
};

export default ChargingRangeForm;